import { Stack, Box, Typography } from "@mui/material";
import {
  FetchSummaryVisitReportType,
  VisitSummaryType,
} from "../../../../../domain/models/daily-visit-report/daily-visit-summary-report";

type props = {
  visitSummary: VisitSummaryType | null;
};

const DataSummary: React.FC<props> = ({ visitSummary }) => {
  return (
    <>
      {visitSummary && (
        <Stack
          direction={"row"}
          paddingY={3}
          borderRadius={"20px"}
          maxWidth={"75%"}
          justifyContent={"space-around"}
          bgcolor={"#f9fafd"}
          marginX={"12%"}
        >
          <Stack marginX={3}>
            <Typography variant="body2">Total TSOs</Typography>
            <Typography color="primary.main" fontWeight={600} variant="h6">
              {visitSummary.total_tso}
            </Typography>
            <Typography variant="body2" fontWeight={550}>
              Coverage: {visitSummary.tso_coverage}%
            </Typography>
          </Stack>
          <Box borderRight="2px solid #e1e3e2" />
          <Stack marginX={3}>
            <Typography variant="body2">Total Customers</Typography>
            <Typography color="primary.main" fontWeight={600} variant="h6">
              {visitSummary.total_customers}
            </Typography>
            <Typography variant="body2" fontWeight={550}>
              bricks: {visitSummary.brick_count}
            </Typography>
          </Stack>
          <Box borderRight="2px solid #e1e3e2" />
          <Stack marginX={3}>
            <Typography variant="body2">Call Average</Typography>
            <Typography color="primary.main" fontWeight={600} variant="h6">
              {visitSummary.call_average}
            </Typography>
            <Typography variant="body2" fontWeight={550}>
              Productivity: {visitSummary.productivity}%
            </Typography>
          </Stack>
          <Box borderRight="2px solid #e1e3e2" />
          <Stack marginX={3}>
            <Typography variant="body2">Total Visits</Typography>
            <Typography color="primary.main" fontWeight={600} variant="h6">
              {visitSummary.total_visit}
            </Typography>
            <Typography variant="body2" fontWeight={550}>
              Growth: {visitSummary.total_visit_growth}%
            </Typography>
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default DataSummary;
